import Request from '../../../../src/core/gd/data/request'

export default class ApiDependency {

    constructor() {
    }

    create(dependency:any) {
        return new Request(this,'POST','dependencies', dependency);
    }

    delete(dependency:any) {

        gd.bus.triggerEvent("api.dependency.delete")

        let requestUri =                            '?type='+       dependency.type;

        if (dependency.task1Id)     requestUri +=   '&task1Id='+    dependency.task1Id;
        if (dependency.project1Id)  requestUri +=   '&project1Id='+ dependency.project1Id;
        if (dependency.event1Id)    requestUri +=   '&event1Id='+   dependency.event1Id;

        if (dependency.task2Id)     requestUri +=   '&task2Id='+    dependency.task2Id;
        if (dependency.project2Id)  requestUri +=   '&project2Id='+ dependency.project2Id;
        if (dependency.event2Id)    requestUri +=   '&event2Id='+   dependency.event2Id;

        return new Request(this,'DELETE','dependencies'+requestUri);
    }

    static getById(id:ID) {
        return new Request(this,'GET','dependency/'+id)
    }
}